import moment from 'moment'

const defaultTimeFormat = 'hh:mm:ss'

/**
 * Parse date string to selected format.
 *
 * @param {string} datetime
 * @param {string} format
 * @returns {string} time
 */
export default function timeFormat(datetime, format = '') {
  return moment(datetime).format(format || defaultTimeFormat)
}
